import { useCallback } from 'react';
import { useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';
import { backendServices } from '../../services';
import { GetSupplierSimRequestParams } from '../../services/backendServices/Apis';

type QueryOptions = Pick<UseQueryOptions, 'enabled' | 'staleTime' | 'cacheTime'>;

function supplierSIMRequestQuery(params: GetSupplierSimRequestParams) {
    return {
        queryKey: ['DocumentType/SupplierSIMRequest', params],
        queryFn: async () => {
            const api = new backendServices.Apis.DocumentTypeApi();
            const res = await api.getSupplierSIMRequest(params);

            return res.data;
        },
    };
}

/** GET /DocumentType/SupplierSIMRequest — open SIM requests targeted at a supplier company. */
export function useGetSupplierSIMRequest(params: GetSupplierSimRequestParams, queryOptions?: QueryOptions) {
    const query = useQuery({
        ...supplierSIMRequestQuery(params),
        ...queryOptions,
    });

    return query;
}

export function useFetchSupplierSIMRequest() {
    const queryClient = useQueryClient();

    return useCallback(
        (params: GetSupplierSimRequestParams) => queryClient.fetchQuery(supplierSIMRequestQuery(params)),
        [queryClient]
    );
}
